import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import BrandLogo from "@/components/marketing/BrandLogo";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(form);
      toast.success("Account created");
      nav("/verify-email", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="signup-page" className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-[#0F1115] text-white">
        <Link to="/" className="flex items-center gap-2">
          <BrandLogo size="md" className="text-white" />
        </Link>
        <div>
          <div className="font-mono text-xs text-white/40">// pay-as-you-go</div>
          <h2 className="font-display font-extrabold text-5xl mt-4 leading-tight">Get your first agent live in 3 minutes.</h2>
          <p className="text-white/60 mt-4">Pick your industry. Pick your use case. We write the first prompt and KB for you.</p>
        </div>
        <ul className="font-mono text-xs space-y-2 text-white/60">
          <li>✓ 100 web chat conversations</li>
          <li>✓ 20 minutes of web voice</li>
          <li>✓ 1 AI agent + 1 site scrape</li>
          <li>✓ No credit card · credits never expire</li>
        </ul>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md space-y-5">
          <div>
            <h1 className="font-display font-extrabold text-4xl">Create your workspace</h1>
            <p className="text-sm text-[#4B5563] mt-2">Already have one? <Link to="/login" className="text-[#0044FF] font-medium" data-testid="signup-to-login-link">Sign in</Link></p>
          </div>
          {[
            { k: "name", label: "Your name", type: "text" },
            { k: "company", label: "Company / workspace", type: "text" },
            { k: "email", label: "Work email", type: "email" },
            { k: "password", label: "Password (min 6)", type: "password" },
          ].map(({ k, label, type }) => (
            <div key={k}>
              <label className="text-sm font-medium block mb-1.5">{label}</label>
              <input
                data-testid={`signup-${k}-input`}
                type={type}
                value={form[k]}
                onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                required
                className="w-full border border-[#E2E8F0] focus:border-[#0044FF] focus:ring-2 focus:ring-[#0044FF]/20 outline-none px-3 py-2.5 rounded-sm"
              />
            </div>
          ))}
          <button data-testid="signup-submit-button" type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60">{busy?"Creating…":"Create workspace"}</button>
        </form>
      </div>
    </div>
  );
}
